import request from '@/utils/request'
export const addReportMsg = (id) => {
  return request.post(`/reports?id=${id}`)
}
